import { PermissionT } from "../types";

export const payTermsUd = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "pay_terms_ud");
  return !!p;
};

export default payTermsUd;
